<!-- Created by kalpesh 26/7/2021 -->
<div class="topDiv" style="height: 60%;">
    <label i18n="@@spmsUserReg" class="textColour">Vault Object Data Extraction</label>
  <span class="example-spacer"></span>
    <div style="margin-top: 25px;">
        <form novalidate [formGroup]='newName_form'>
                <mat-form-field appearance="outline" style="width: 90%;">
                <mat-label i18n="@@RCFormulaexpression">Add Name</mat-label>
                <input matInput type="text" placeholder="Add Name" formControlName="name" [(ngModel)]="namedata.name" (change)="namedata.name = namedata.name.trim()"  maxlength="100" required>
                    <mat-error *ngFor="let validation of validation_messages.name">
                    <span
                        *ngIf="newName_form.get('name').hasError(validation.type) && (newName_form.get('name').dirty || newName_form.get('name').touched)">
                        {{ validation.message }}
                    </span>
                    </mat-error>
                </mat-form-field>
        </form>
    </div>

    <div class="row mb-1 topRowMargins" style="position:sticky;left:0;bottom:0;width:100%;margin-top:300px;">

        <div class="col-lg text-center" >

            <div style="text-align: end">

                    <button i18n="@@TargetClear" [disabled]="!newName_form.valid" type="button" (click)="addNewName()"
                    class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    style="padding-left:1.2rem;padding-right: 1.2rem" [style.background-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean">ADD</button>

                    <button i18n="@@TargetCancel" type="button" (click)="cancel()"
                    class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    style="padding-left:1.2rem;padding-right: 1.2rem" [style.border-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean" >Cancel</button>        


            </div>

        </div>
        
    </div>
</div>
